module.exports = __webpack_public_path__ + "img/china1.3cd8cf68.jpg";